import fetchClient from './index';
import {BASE_URL, endPoints} from './urls';
export const verifySubscription = async () => {
  try {
    const response = await fetchClient().get(`${BASE_URL}${endPoints.CHECK_USER_SUBSCRIPTION}`, {});
    return response;
  } catch (e) {
    console.log('errorrr', e);
    return e;
  }
};

export const getCustmerProtal = async () => {
  try {
    const response = await fetchClient().post(
      `${BASE_URL}${endPoints.CHECK_CUSTOMER_SUBSCRIPTION}`,
      {}
    );
    return response;
  } catch (e) {
    console.log('errorrr', e);
    return e;
  }
};
